import { useState, useEffect } from "react";
import useApi from "../../hooks/useApiGetPost";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import * as XLSX from "xlsx";

export default function PriceUpdater() {
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [decimalPlace, setDecimalPlace] = useState(3);
  const [isExcelData, setIsExcelData] = useState(false);

  const [pendingPage, setPendingPage] = useState(null);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [editedRows, setEditedRows] = useState(new Set());
  const [data, setData] = useState([]);
  const [group, setGroup] = useState("-");
  const [subGroup, setSubGroup] = useState("-");
  const [category, setCategory] = useState("-");
  const [subCategory, setSubCategory] = useState("-");
  const [subfilter, setSubfilter] = useState("-");
  const [location, setLocation] = useState("-");

  const [roundOff, setRoundOff] = useState(false);
  const [selectedRow, setSelectedRow] = useState(0);
  const [cashPct, setCashPct] = useState("");
  const [creditPct, setCreditPct] = useState("");
  const [splPricePct, setSplPricePct] = useState("");
  const [blockPct, setBlockPct] = useState("");
  const [dcpPct, setDcpPct] = useState("");
  const [priceType, setPriceType] = useState("Price");
  const [fileName, setFileName] = useState("");

  const {
    data: datagetLocationList,
    loading: loadingGetLocationList,
    get: getLocationList,
  } = useApi();

  const {
    data: datagetGetListOfItems,
    loading: loadingGetListOfItems,
    get: callApiToGetListOfItems,
  } = useApi();

  const {
    loading: loadinggetSubCategory,
    data: datagetSubCategory,
    get: getSubCategory,
  } = useApi();

  const {
    loading: loadinggetCategory,
    data: datagetCategory,
    get: getCategory,
  } = useApi();
  const {
    loading: loadinggetSubgroup,
    data: datagetSubgroup,
    get: getSubgroup,
  } = useApi();
  const {
    loading: loadinggetgroup,
    data: datagetgroup,
    get: getgroup,
  } = useApi();

  const {
    loading: loadingpostCallUpdatePriceApi,
    data: datapostCallUpdatePriceApi,
    post: postCallUpdatePriceApi,
  } = useApi();

  useEffect(() => {
    if (datapostCallUpdatePriceApi) {
      if (datapostCallUpdatePriceApi.result?.trim()?.toUpperCase() === "SAVED") {
        setSnack({
          open: true,
          message: `Price Updated`,
          type: "success",
        });

        setEditedRows(new Set()); // clear after update
      } else {
        setSnack({
          open: true,
          message: "Failed to updatePrice",
          type: "error",
        });
      }
    }
  }, [datapostCallUpdatePriceApi]);

  const callUpdateApi = (arrayOfSelectedItems) => {
    let manipulatedArrayToSendToAPI = arrayOfSelectedItems.map((items) => {
      return {
        CMPCODE: COMPANY_CODE,
        code: items.code,
        cost_fifo: items.dcp, // dcp
        price3: items.blockPrice, // block price
        price_unit: items.cashPrice, // cash price
        price2: items.creditPrice, // credit price
        priced: items.splPrice, // special price
      };
    });

    console.log("arrayOfSelectedItems ", arrayOfSelectedItems);

    let apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMPriceListReg`;

    let serializedData = JSON.stringify(manipulatedArrayToSendToAPI);
    console.log("manipulatedArrayToSendToAPI ", serializedData);

    postCallUpdatePriceApi(apiUrl, serializedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const handleUpdate = () => {
    const editedData = data.filter((_, idx) => editedRows.has(idx));

    if (editedData.length === 0) {
      alert("No changes to update.");
      return;
    }

    console.log("Rows to send to API:", editedData);

    // Replace with your actual API call:
    callUpdateApi(editedData);
  };

  const handleShowItem = (pageNum = page, limitNum = limit) => {
    setData([]); // ← add this
    setIsExcelData(false); // ← add
    setEditedRows(new Set()); // ← add this
    const encode = (val) => (val ? encodeURIComponent(val) : "-");

    const locationToPassToApi = encode(location);
    const groupToPassToAPI = encode(group);
    const sgroupToPassToAPI = encode(subGroup);
    const categoryToPassToAPI = encode(category);
    const scategoryToPassToAPI = encode(subCategory);
    const subfilterToPassToAPI = encode(subfilter);

    const today = new Date().toISOString().split("T")[0];

    let apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMPriceList/${COMPANY_CODE}/PRICING/${today}/${groupToPassToAPI}/${sgroupToPassToAPI}/${categoryToPassToAPI}/${scategoryToPassToAPI}/${subfilterToPassToAPI}/${locationToPassToApi}/${pageNum}/${limitNum}`;

    callApiToGetListOfItems(apiUrl);
  };

  // Maps API response keys to internal col keys
  const mapApiItem = (item) => ({
    code: item["CODE"],
    description: item["Description"],
    creditPrice_P: item["Credit Price_P%"],
    creditPrice: item["Credit Price"],
    creditPrice_original_from_api: item["Credit Price"], // ← add
    cashPrice_P: item["Cash Price_P%"],
    cashPrice: item["Cash Price"],
    cashPrice_original_from_api: item["Cash Price"], // ← add
    splPrice_P: item["Spl.Price_P%"],
    splPrice: item["Spl.Price"],
    splPrice_original_from_api: item["Spl.Price"], // ← add
    blockPrice_P: item["Block Price_P%"],
    blockPrice: item["Block Price"],
    blockPrice_original_from_api: item["Block Price"], // ← add
    dcp_P: item["DCP_P%"],
    dcp: item["DCP"],
    dcp_original_from_api: item["DCP"], // ← add
    cost: item["COST"],
    lp_cost: item["LP_COST"],
    group: item["Group"],
    oem: item["OEM"],
    subGroup: item["Sub Group"],
    category: item["Category"],
    qty: item["QTY"],
  });

  useEffect(() => {
    if (datagetGetListOfItems) {
      const mapped = Array.isArray(datagetGetListOfItems)
        ? datagetGetListOfItems.map(mapApiItem)
        : [];

      // re-apply active percentages to newly loaded data
      const applied = mapped.map((row) => {
        let updated = { ...row };

        if (creditPct !== "") {
          const pct = parseFloat(creditPct) || 0;
          const original = parseFloat(row.creditPrice_original_from_api) ?? 0;
          updated.creditPrice = parseFloat(
            (original + (original * pct) / 100).toFixed(decimalPlace),
          );
          updated.creditPrice_P = creditPct;
        }

        if (cashPct !== "") {
          const pct = parseFloat(cashPct) || 0;
          const original = parseFloat(row.cashPrice_original_from_api) ?? 0;
          updated.cashPrice = parseFloat(
            (original + (original * pct) / 100).toFixed(decimalPlace),
          );
          updated.cashPrice_P = cashPct;
        }

        if (splPricePct !== "") {
          const pct = parseFloat(splPricePct) || 0;
          const original = parseFloat(row.splPrice_original_from_api) ?? 0;
          updated.splPrice = parseFloat(
            (original + (original * pct) / 100).toFixed(decimalPlace),
          );
          updated.splPrice_P = splPricePct;
        }

        if (blockPct !== "") {
          const pct = parseFloat(blockPct) || 0;
          const original = parseFloat(row.blockPrice_original_from_api) ?? 0;
          updated.blockPrice = parseFloat(
            (original + (original * pct) / 100).toFixed(decimalPlace),
          );
          updated.blockPrice_P = blockPct;
        }

        if (dcpPct !== "") {
          const pct = parseFloat(dcpPct) || 0;
          const original = parseFloat(row.dcp_original_from_api) ?? 0;
          updated.dcp = parseFloat(
            (original + (original * pct) / 100).toFixed(decimalPlace),
          );
          updated.dcp_P = dcpPct;
        }

        return updated;
      });

      setData(applied);
      // mark all rows as edited if any pct is active
      if (
        creditPct !== "" ||
        cashPct !== "" ||
        splPricePct !== "" ||
        blockPct !== "" ||
        dcpPct !== ""
      ) {
        setEditedRows(new Set(applied.map((_, idx) => idx)));
      }
    }
  }, [datagetGetListOfItems]);

  useEffect(() => {
    getLocationList(
      `${API_PATHS[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/LOCATONLIST_ALL/-/-`,
    );

    getCategory(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/category/-/-`,
    );

    getSubCategory(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/subcategory/-/-`,
    );

    getgroup(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/group/-/-`,
    );
    getSubgroup(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/subgroup/-/-`,
    );
  }, []);

  const handleCellChange = (rowIdx, field, value) => {
    setData(
      (prev) =>
        prev.map((row, i) => (i === rowIdx ? { ...row, [field]: value } : row)), // keep as string while typing
    );
    setEditedRows((prev) => new Set(prev).add(rowIdx));
  };

  const handleCellBlur = (rowIdx, field, value) => {
    setData((prev) =>
      prev.map(
        (row, i) =>
          i === rowIdx ? { ...row, [field]: parseFloat(value) || 0 } : row, // convert to number on blur
      ),
    );
  };

  const handleCreditPctChange = (value) => {
    setCreditPct(value);
    setData((prev) =>
      prev.map((row) => {
        const pct = value === "" ? 0 : parseFloat(value) || 0;
        const original = parseFloat(row.creditPrice_original_from_api) ?? 0;
        const newPrice = original + (original * pct) / 100;
        const finalPrice = value === "" ? original : newPrice;
        return {
          ...row,
          creditPrice_P: value,
          creditPrice: parseFloat(finalPrice.toFixed(decimalPlace)),
        };
      }),
    );
    setEditedRows(new Set(data.map((_, idx) => idx)));
  };

  const handleCashPctChange = (value) => {
    setCashPct(value);

    setData((prev) =>
      prev.map((row) => {
        const pct = value === "" ? 0 : parseFloat(value) || 0;
        const original = parseFloat(row.cashPrice_original_from_api) ?? 0;
        const newPrice = original + (original * pct) / 100;
        const finalPrice = value === "" ? original : newPrice;
        return {
          ...row,
          cashPrice_P: value,
          cashPrice: parseFloat(finalPrice.toFixed(decimalPlace)),
        };
      }),
    );
    setEditedRows(new Set(data.map((_, idx) => idx)));
  };

  const handleSplPricePctChange = (value) => {
    setSplPricePct(value);

    setData((prev) =>
      prev.map((row) => {
        const pct = value === "" ? 0 : parseFloat(value) || 0;
        const original = parseFloat(row.splPrice_original_from_api) ?? 0;
        const newPrice = original + (original * pct) / 100;
        const finalPrice = value === "" ? original : newPrice;
        return {
          ...row,
          splPrice_P: value,
          splPrice: parseFloat(finalPrice.toFixed(decimalPlace)),
        };
      }),
    );
    setEditedRows(new Set(data.map((_, idx) => idx)));
  };

  const handleBlockPctChange = (value) => {
    setBlockPct(value);

    setData((prev) =>
      prev.map((row) => {
        const pct = value === "" ? 0 : parseFloat(value) || 0;
        const original = parseFloat(row.blockPrice_original_from_api) ?? 0;
        const newPrice = original + (original * pct) / 100;
        const finalPrice = value === "" ? original : newPrice;
        return {
          ...row,
          blockPrice_P: value,
          blockPrice: parseFloat(finalPrice.toFixed(decimalPlace)),
        };
      }),
    );
    setEditedRows(new Set(data.map((_, idx) => idx)));
  };

  const handleDcpPctChange = (value) => {
    setDcpPct(value);

    setData((prev) =>
      prev.map((row) => {
        const pct = value === "" ? 0 : parseFloat(value) || 0;
        const original = parseFloat(row.dcp_original_from_api) ?? 0;
        const newPrice = original + (original * pct) / 100;
        const finalPrice = value === "" ? original : newPrice;
        return {
          ...row,
          dcp_P: value,
          dcp: parseFloat(finalPrice.toFixed(decimalPlace)),
        };
      }),
    );
    setEditedRows(new Set(data.map((_, idx) => idx)));
  };

  const handleDownloadExcelFormat = () => {
    const templateRows = [
      {
        CODE: "SAMPLE001",
        "Credit Price": 0,
        "Cash Price": 0,
        "Spl.Price": 0,
        "Block Price": 0,
        DCP: 0,
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(templateRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Price Template");
    XLSX.writeFile(workbook, "price_upload_template.xlsx");
  };

  const cols = [
    { key: "code", label: "CODE", bg: "bg-white", width: "w-28" },
    { key: "description", label: "Description", bg: "bg-white", width: "w-52" },
    {
      key: "creditPrice_P",
      label: "Credit Price_P%",
      width: "w-24",
    },
    {
      key: "creditPrice",
      label: "Credit Price",
      bg: "bg-gray-300",
      width: "w-20",
      minWidth: 120,
    },
    {
      key: "cashPrice_P",
      label: "Cash Price_P%",
      width: "w-20",
    },
    {
      key: "cashPrice",
      label: "Cash Price",
      bg: "bg-gray-300",
      width: "w-20",
      minWidth: 120,
    },
    {
      key: "splPrice_P",
      label: "Spl.Price_P%",
      width: "w-20",
    },
    {
      key: "splPrice",
      label: "Spl.Price",
      bg: "bg-gray-300",
      width: "w-20",
      minWidth: 120,
    },
    {
      key: "blockPrice_P",
      label: "Block Price_P%",
      width: "w-24",
    },
    {
      key: "blockPrice",
      label: "Block Price",
      bg: "bg-gray-300",
      width: "w-20",
      minWidth: 120,
    },
    {
      key: "dcp_P",
      label: "DCP_P%",
      width: "w-24",
      minWidth: 120,
    },
    {
      key: "dcp",
      label: "DCP",
      bg: "bg-gray-300",
      width: "w-24",
      minWidth: 120,
    },
    { key: "cost", label: "COST", bg: "bg-white", width: "w-16" },
    {
      key: "lp_cost",
      label: "LP_COST",
      bg: "bg-white",
      width: "w-16",
      minWidth: 120,
    },
    { key: "group", label: "Group", bg: "bg-white", width: "w-24" },
    { key: "oem", label: "OEM", bg: "bg-white", width: "w-16" },
    { key: "subGroup", label: "Sub Group", bg: "bg-white", width: "w-20" },
    { key: "category", label: "Category", bg: "bg-white", width: "w-20" },
    { key: "qty", label: "QTY", bg: "bg-white", width: "w-12" },
  ];

  const handleExcelUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const workbook = XLSX.read(evt.target.result, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        if (rows.length === 0) {
          setSnack({
            open: true,
            message: "Excel file is empty.",
            type: "warning",
          });
          e.target.value = "";
          return;
        }

        const mapped = rows.map((excelRow) => ({
          code: excelRow["CODE"] ?? "",
          description: excelRow["Description"] ?? "",
          creditPrice_P: excelRow["Credit Price_P%"] ?? "",
          creditPrice: parseFloat(excelRow["Credit Price"]) || 0,
          creditPrice_original_from_api:
            parseFloat(excelRow["Credit Price"]) || 0,
          cashPrice_P: excelRow["Cash Price_P%"] ?? "",
          cashPrice: parseFloat(excelRow["Cash Price"]) || 0,
          cashPrice_original_from_api: parseFloat(excelRow["Cash Price"]) || 0,
          splPrice_P: excelRow["Spl.Price_P%"] ?? "",
          splPrice: parseFloat(excelRow["Spl.Price"]) || 0,
          splPrice_original_from_api: parseFloat(excelRow["Spl.Price"]) || 0,
          blockPrice_P: excelRow["Block Price_P%"] ?? "",
          blockPrice: parseFloat(excelRow["Block Price"]) || 0,
          blockPrice_original_from_api:
            parseFloat(excelRow["Block Price"]) || 0,
          dcp_P: excelRow["DCP_P%"] ?? "",
          dcp: parseFloat(excelRow["DCP"]) || 0,
          dcp_original_from_api: parseFloat(excelRow["DCP"]) || 0,
          cost: excelRow["COST"] ?? "",
          lp_cost: excelRow["LP_COST"] ?? "",
          group: excelRow["Group"] ?? "",
          oem: excelRow["OEM"] ?? "",
          subGroup: excelRow["Sub Group"] ?? "",
          category: excelRow["Category"] ?? "",
          qty: excelRow["QTY"] ?? "",
        }));

        setData(mapped);
        setIsExcelData(true); // ← add
        setEditedRows(new Set(mapped.map((_, idx) => idx))); // should we consider like if data is uploaded from excel then that all rows are edited, what if some rows need to be removed and something like that?

        setSnack({
          open: true,
          message: `${mapped.length} rows loaded from Excel!`,
          type: "success",
        });
      } catch (err) {
        console.error("Excel parse error:", err);
        setSnack({
          open: true,
          message: "Failed to read Excel file.",
          type: "error",
        });
      }
    };

    reader.readAsArrayBuffer(file);
    e.target.value = "";
  };

  return (
    <div
      className="flex flex-col h-screen bg-gray-100 text-xs"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* Title Bar */}
      <div className="p-4 border-b border-gray-200">
        <span className="text-xl font-bold text-gray-900">PRICE UPDATER</span>
      </div>

      <div>
        <button
          onClick={() => handleShowItem()}
          className="bg-gray-200 text-gray-800 border border-gray-400 px-3 py-0.5 rounded hover:bg-gray-300 font-semibold ml-2"
        >
          SHOW ITEM
        </button>
        <button
          onClick={handleUpdate}
          disabled={loadingpostCallUpdatePriceApi}
          className="bg-teal-700 text-white px-4 py-0.5 rounded hover:bg-teal-800 font-semibold ms-4 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loadingpostCallUpdatePriceApi ? "Updating..." : "UPDATE PRICE"}
        </button>
      </div>
      {/* Toolbar Row 1 */}
      <div className="px-3 py-1.5 flex flex-wrap items-center gap-2">
        <label className="text-black font-semibold">Location</label>
        <select
          className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-36"
          value={location}
          onChange={(e) => {
            setLocation(e.target.value);
            setPage(1);
            setData([]);
          }}
        >
          <option></option>
          {datagetLocationList?.map((item, index) => (
            <option key={index} value={item["loc_code"]}>
              {item["DESC"]}
            </option>
          ))}
        </select>

        <label className="text-black font-semibold">Group</label>
        <select
          className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-36"
          value={group}
          onChange={(e) => {
            setGroup(e.target.value);
            setPage(1);
            setData([]);
          }}
        >
          <option></option>
          {datagetgroup?.map((item, index) => (
            <option key={index}>{item["GRP CODE"]}</option>
          ))}
        </select>

        <label className="text-black font-semibold ml-2">Sub Group</label>
        <select
          className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-28"
          value={subGroup}
          onChange={(e) => {
            setSubGroup(e.target.value);
            setPage(1);
            setData([]);
          }}
        >
          <option value=""></option>
          {datagetSubgroup?.map((item, index) => (
            <option key={index}>{item["GRP CODE"]}</option>
          ))}
        </select>

        <label className="text-black font-semibold ml-2">Category</label>
        <select
          className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-28"
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            setPage(1);
            setData([]);
          }}
        >
          <option value=""></option>
          {datagetCategory?.map((item, index) => (
            <option key={index}>{item["GRP CODE"]}</option>
          ))}
        </select>

        <label className="text-black font-semibold ml-2">Sub Category</label>
        <select
          className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-28"
          value={subCategory}
          onChange={(e) => {
            setSubCategory(e.target.value);
            setPage(1);
            setData([]);
          }}
        >
          <option value=""></option>
          {datagetSubCategory?.map((item, index) => (
            <option key={index}>{item["GRP CODE"]}</option>
          ))}
        </select>

        <button
          onClick={() => handleDownloadExcelFormat()}
          className="bg-gray-700 text-white px-2 py-0.5 rounded font-bold hover:bg-red-600 ml-1"
        >
          download format
        </button>

        <label className="bg-green-700 text-white px-2 py-0.5 rounded font-bold hover:bg-green-800 ml-1 cursor-pointer">
          excel upload
          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            className="hidden"
            onChange={handleExcelUpload}
          />
        </label>

        {/* <label className="flex items-center gap-1 text-black ml-2 cursor-pointer">
          <input
            type="checkbox"
            checked={roundOff}
            onChange={(e) => setRoundOff(e.target.checked)}
            className="accent-white"
          />
          Round Off
        </label> */}
      </div>

      {/* Toolbar Row 2 */}
      <div className="px-3 py-1.5 flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1">
          <span className="text-black font-semibold">%Cash</span>
          <input
            type="number"
            min="0"
            value={cashPct}
            onChange={(e) => handleCashPctChange(e.target.value)}
            className="border border-gray-300 rounded px-1 py-0.5 bg-white w-16 text-xs"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-black font-semibold">%Credi</span>
          <input
            type="number"
            min="0"
            value={creditPct}
            onChange={(e) => handleCreditPctChange(e.target.value)}
            className="border border-gray-300 rounded px-1 py-0.5 bg-white w-16 text-xs"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-black font-semibold">%SplPric</span>
          <input
            type="number"
            min="0"
            value={splPricePct}
            onChange={(e) => handleSplPricePctChange(e.target.value)}
            className="border border-gray-300 rounded px-1 py-0.5 bg-white w-16 text-xs"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-black font-semibold">%Bloc</span>
          <input
            type="number"
            min="0"
            value={blockPct}
            onChange={(e) => handleBlockPctChange(e.target.value)}
            className="border border-gray-300 rounded px-1 py-0.5 bg-white w-16 text-xs"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-black font-semibold">%DCP</span>
          <input
            type="number"
            min="0"
            value={dcpPct}
            onChange={(e) => handleDcpPctChange(e.target.value)}
            className="border border-gray-300 rounded px-1 py-0.5 bg-white w-16 text-xs"
          />
        </div>

        {/* <div className="flex items-center gap-1 ml-2">
          <span className="text-blackfont-semibold">Excel Upload</span>
          <button
            onClick={handleFileSelect}
            className="bg-red-600 text-white px-3 py-0.5 rounded font-bold hover:bg-red-700"
          >
            SELECT FILE
          </button>
        </div> */}

        {/* <div className="flex items-center gap-1">
          <span className="text-black font-semibold">Price</span>
          <select
            className="border border-gray-300 rounded px-1 py-0.5 bg-white text-xs w-24"
            value={priceType}
            onChange={(e) => setPriceType(e.target.value)}
          >
            <option>Price</option>
            <option>Cost</option>
            <option>LP Cost</option>
          </select>
        </div>

        <button
          onClick={handleUpdate}
          className="bg-green-600 text-white px-6 py-0.5 rounded font-bold hover:bg-green-700"
        >
          UPDATE
        </button> */}
      </div>

      <div className="p-4">
        {/* Pagination — always visible when page > 1 or data exists */}
        {(data.length > 0 || page > 1) && !isExcelData && (
          <div className="flex items-center gap-3 px-4 py-2 border-t border-gray-200 bg-white">
            <button
              onClick={() => {
                const newPage = Math.max(1, page - 1);
                if (editedRows.size > 0) {
                  setPendingPage(newPage);
                } else {
                  setPage(newPage);
                  handleShowItem(newPage, limit);
                }
              }}
              disabled={page === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300"
            >
              ← Prev
            </button>

            <span className="text-sm text-gray-600">Page {page}</span>

            <button
              onClick={() => {
                const newPage = page + 1;
                if (editedRows.size > 0) {
                  console.log("editedRows", editedRows);
                  setPendingPage(newPage); // show modal
                } else {
                  setPage(newPage);
                  handleShowItem(newPage, limit);
                }
              }}
              className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
            >
              Next →
            </button>

            <span className="text-sm text-gray-600 ml-4">Rows per page:</span>
            <select
              value={limit}
              onChange={(e) => {
                const newLimit = Number(e.target.value);
                setLimit(newLimit);
                setPage(1);
                handleShowItem(1, newLimit);
              }}
              className="border border-gray-300 rounded px-1 py-0.5 text-xs"
            >
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>

            <span className="text-sm text-gray-500">
              Showing {data.length} items
            </span>
          </div>
        )}

        {loadingGetListOfItems ? (
          /* 1. Loading State */
          <div className="flex flex-col items-center justify-center py-10">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-blue-500"></div>
            <p className="mt-4 text-sm font-medium text-gray-500">
              Fetching items...
            </p>
          </div>
        ) : data.length > 0 ? (
          /* 2. Data State (Show your list here) */

          <div className="flex-1 overflow-auto bg-white mt-4">
            <table
              className="border-collapse w-full"
              style={{ minWidth: "1400px" }}
            >
              <thead>
                {/* Label header row */}
                <tr className="bg-teal-600 text-white">
                  {cols.map((col) => (
                    <th
                      key={col.key}
                      className={`border border-gray-400 px-1 py-1 text-left font-semibold whitespace-nowrap bg-gray-300 text-black`}
                      style={{ fontSize: 14, minWidth: col.minWidth }}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIdx) => (
                  <tr
                    key={rowIdx}
                    onClick={() => setSelectedRow(rowIdx)}
                    className={`cursor-pointer ${
                      selectedRow === rowIdx
                        ? "bg-blue-100 border-l-4 border-blue-500"
                        : editedRows.has(rowIdx) // ← add this condition
                          ? "bg-yellow-100" // ← edited row color
                          : rowIdx % 2 === 0
                            ? "bg-white"
                            : "bg-sky-50"
                    } hover:bg-blue-50 transition-colors`}
                  >
                    {cols.map((col) => (
                      <td
                        key={col.key}
                        className={`border border-gray-200 px-1 py-0.5 ${
                          selectedRow === rowIdx ? "" : col.bg
                        }`}
                        style={{ fontSize: 14, minWidth: col.minWidth }}
                      >
                        {[
                          "creditPrice",
                          "cashPrice",
                          "splPrice",
                          "blockPrice",
                          "dcp",
                        ].includes(col.key) ? (
                          <input
                            type="number"
                            min="0"
                            value={row[col.key]}
                            onBlur={(e) =>
                              handleCellBlur(rowIdx, col.key, e.target.value)
                            } // ← add this
                            onChange={(e) =>
                              handleCellChange(rowIdx, col.key, e.target.value)
                            }
                            className="w-full bg-white text-right px-2 py-1 border border-gray-300 rounded-md 
             focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent 
             transition-all duration-200 hover:border-gray-400"
                            style={{ fontSize: 14 }}
                          />
                        ) : (
                          <span
                            className={
                              col.key === "qty" && row[col.key] < 0
                                ? "text-red-600 font-semibold"
                                : ""
                            }
                          >
                            {row[col.key]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          /* 3. Empty State (No Data) */
          <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 py-12">
            <svg
              className="h-12 w-12 text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="box-open"
              />
              <circle cx="12" cy="12" r="9" strokeWidth="2" />
            </svg>
            <span className="mt-2 text-lg font-semibold text-gray-400">
              No data to show
            </span>
            <p className="text-sm text-gray-400">
              Try adjusting your filters or search terms.
            </p>
          </div>
        )}
      </div>

      {pendingPage && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-80">
            <h3 className="text-base font-bold text-gray-800 mb-2">
              Unsaved Changes
            </h3>
            <p className="text-sm text-gray-600 mb-5">
              You have unsaved changes. What would you like to do?
            </p>
            <div className="flex gap-2 justify-end">
              {/* Cancel — stay on current page */}
              <button
                onClick={() => setPendingPage(null)}
                className="px-3 py-1.5 text-xs rounded border border-gray-300 hover:bg-gray-100"
              >
                Stay on Page
              </button>

              {/* Discard — lose changes, go to next page */}
              <button
                onClick={() => {
                  setEditedRows(new Set());
                  setPage(pendingPage);
                  handleShowItem(pendingPage, limit);
                  setPendingPage(null);
                }}
                className="px-3 py-1.5 text-xs rounded bg-red-500 text-white hover:bg-red-600"
              >
                Discard & Continue
              </button>

              {/* Save — save first, then go to next page */}
              <button
                onClick={() => {
                  handleUpdate(); // save edits
                  setPage(pendingPage);
                  handleShowItem(pendingPage, limit);
                  setPendingPage(null);
                }}
                className="px-3 py-1.5 text-xs rounded bg-teal-600 text-white hover:bg-teal-700"
              >
                Save & Continue
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
